/**
 * Convert encrypted links (in Navigation and Footer)
 *
 * Due to SEO reasons some links have a `#` as href attribute and also an
 * encrypted-url data-attribute with the base64 encoded url.
 * Here we handle the transformation.
 *
 * @url https://prom.circit.de/jira/browse/GERACM-11341
 * */

 (() => {
   const decryptLinks = () => {
     const encryptedLinks = document.querySelectorAll('a[data-encrypted-url]');

     if (encryptedLinks.length === 0) {
       return;
     }

    /**
      * Sets the `href` attribute of a LinkElement using the
      * decrypted `data-encrypted-url` attribute value.
      * @param link: object von
      * @return Void
      */
     const convertEncryptedLink = (link) => {
       const encryptedUrl = link.dataset.encryptedUrl;
       if (!encryptedUrl) {
         return;
       }

       const href = link.getAttribute('href');
       if (href !== '#' && link.length > 1) {
        // There is already a href set, so we won't override it.
         return;
       }

       // Attention: We do not handle Unicode Strings here (just a basic base64 conversion)
       // If needed (e.g. for Emojis (who does not want to use Emojis in URLs?!) see https://developer.mozilla.org/en-US/docs/Web/API/btoa
       const decryptedUrl = atob(encryptedUrl);

       link.setAttribute('href', decryptedUrl);
     };

     // Convert all encrypted links
     encryptedLinks.forEach(link => convertEncryptedLink(link));
   };

   // export the functionality to be used when navigation is added later on
   window.park = Object.assign({}, window.park, {
     decryptLinks,
   });

   // already decrypt links
   decryptLinks();
 })();
